import * as BulkImport from './BulkImport.styles'

export default {
  ...BulkImport,
}
